import React, { useEffect, useState } from "react";
import useTrafficPayment from "../../views/payment/useTrafficPayment";
import useCivilEFilePayment from"../../views/civil/new-case/e-file-payment/useCivilEFilePayment"

type FetchProps = {
  url?: string;
  children: (response: any) => React.ReactElement<any>;
  amount: number;
  paymentType?: string;
};

export const Fetch: React.FC<FetchProps> = (props) => {
  const { res, handleMakePayment } = props?.paymentType == "civil" ? useCivilEFilePayment() : useTrafficPayment();

  useEffect(() => { 
    console.log(props);
    const fetchData = async () => {
      const data = await handleMakePayment(props.amount);
      console.log(data);
    };
    fetchData();
  }, [props.amount]);


  return res ? props.children(res) : null;
};

export default Fetch;
